import type {ListRepresentativesSearch} from "../-types";

import {PageContainerSkeleton, TableSkeleton, ToolbarSkeleton} from "@project/components/feedback";

import {representativesRouteApi} from "../-route-api";

export function RepresentativesPending() {
  const search = representativesRouteApi.useSearch() as ListRepresentativesSearch;
  const perPage = search.perPage ?? 20;

  return (
    <PageContainerSkeleton>
      <ToolbarSkeleton>
        <div className="flex w-full gap-3 @lg:w-auto">
          <div className="flex-1 @lg:flex-none">
            <ToolbarSkeleton.Input />
          </div>
          <div className="hidden @lg:inline-flex">
            <ToolbarSkeleton.Button />
          </div>
          <div className="flex @lg:hidden">
            <ToolbarSkeleton.Button className="w-10" />
          </div>
        </div>
        <ToolbarSkeleton.Actions className="hidden @lg:flex">
          <ToolbarSkeleton.Button />
        </ToolbarSkeleton.Actions>
      </ToolbarSkeleton>

      <TableSkeleton columns={6} rows={perPage} />
    </PageContainerSkeleton>
  );
}
